import { ListItemButton, Box, Typography, ListItemButtonProps } from '@mui/material';
import { AddCircleOutline as AddCircleOutlineIcon } from '@mui/icons-material';
import { listItemButtonStyles } from '../ListItemWideButton';
import { addIconStyle, buttonBoxStyle } from '../../style';

export type AddButtonProps = Pick<ListItemButtonProps, 'onClick'> & {
    text: string;
};

const AddButton = ({ onClick, text }: AddButtonProps) => {
    return (
        <ListItemButton sx={listItemButtonStyles} onClick={onClick}>
            <Box sx={buttonBoxStyle}>
                <AddCircleOutlineIcon sx={addIconStyle} />
                <Typography variant="h4" sx={{ color: (t) => t.palette.primary.light }}>
                    {text}
                </Typography>
            </Box>
        </ListItemButton>
    );
};

export default AddButton;
